import React, { Component } from "react";
import moment from "moment";

function DateFormatter({ date, format }) {
  return moment(parseInt(date)).format("dd, MMMM Do YYYY, h:mm:ss a");
}

export default React.memo(DateFormatter);
